
import request from '../../src/util/request'
 

// get请求
export function getFunc(url,params) {
    return request({
        url: url, // 请求路径，会自动拼接上baseUrl
        method: 'get',
        data: params,
        showLoading: true
    })
}
 
// post请求和get请求用法完全一致
export function postFunc(url,params) {
    return request({
        url: url,
        method: 'post',
        data: params,
        showLoading: true
    })
}
 
// 自定义请求头
export function uploadFile(url,params){
    return request({
        url: url,
        method:'post',
        headers: { 
            "Content-Type": "multipart/form-data; boundary=----WebKitFormBoundaryOwZABrTBFT4LPAaB" 
        }, 
        data: params
    })
}